export default __webpack_public_path__ + "static/media/Shivraj Singh.cc0207cf.png";